<template>
  <div class="join-us-page">
    <div v-html="richText"></div>
  </div>
</template>

<script>
import requestApi from '@/service';

export default {
  data() {
    return {
      richText: '',
    };
  },
  activated() {
    this.getRichText();
  },
  methods: {
    getRichText() {
      requestApi('/v3/api/site/about/', {
        type: 3,
      }).then(res => {
        this.richText = res.content;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.join-us-page {
  padding: 20px 30px;
}
</style>
